import { Button } from '@/modules/shared/components/ui/button'
import { Layout } from '@/modules/shared/layouts/layout'
import { useNavigate } from 'react-router-dom'
import {
  ComparativePeriodFilter,
  comparativeMonths,
} from '../components/comparative-sellers/comparative-period-filter'
import { useComparativeReport } from '../hooks/use-comparative-report.hook'
import ComparitiveSellersInterface from '../interfaces/comparative-sellers.interface'
import type { ComparativeSeller } from '../types/comparative-report.type'

const emptySellers: ComparativeSeller[] = []

export function ComparativeSellersContainer() {
  const navigate = useNavigate()
  const {
    data,
    isFetching,
    isError,
    error,
    period,
    draftPeriod,
    setDraftPeriod,
    search,
    refetch,
  } = useComparativeReport()
  const ready = !isFetching && !isError && !!data

  return (
    <Layout
      pageTitle="Relatório Comparativo"
      handleGoBack={() => navigate('/relatorios')}
    >
      <div className="mx-auto max-w-5xl space-y-4 pb-6">
        <ComparativePeriodFilter
          value={draftPeriod}
          onChange={setDraftPeriod}
          onSearch={search}
          loading={isFetching}
        />
        <p className="text-sm text-muted-foreground">
          Período consultado: {comparativeMonths[Number(period.mes) - 1]} de{' '}
          {period.ano}
        </p>
        {isFetching && (
          <p role="status" className="py-8 text-center">
            Carregando comparativo...
          </p>
        )}
        {!isFetching && isError && (
          <div
            role="alert"
            className="space-y-3 rounded-md border bg-background p-4"
          >
            <p>
              {error instanceof Error && error.message.trim()
                ? error.message
                : 'Não foi possível carregar o comparativo. Tente novamente.'}
            </p>
            <Button variant="outline" onClick={() => void refetch()}>
              Tentar novamente
            </Button>
          </div>
        )}
        {ready && data.length === 0 && (
          <p role="status" className="py-8 text-center">
            Nenhum vendedor encontrado para este período.
          </p>
        )}
        <ComparitiveSellersInterface
          sellers={data ?? emptySellers}
          enabled={ready}
        />
      </div>
    </Layout>
  )
}
